import { createActions } from 'utils/actions';

/**
 * Redux actions for fetching the signing url for HelloSign embedded signature.
 *
 * @type {Object}
 */
export const fetchSigningUrl = createActions('hellosign', 'FETCH_SIGNING_URL', { asPromise: true });

/**
 * Redux actions for fetching the handbook pdf url.
 *
 * @type {Object}
 */
export const fetchPdfUrl = createActions('hellosign', 'FETCH_HANDBOOK_PDF_URL', {
    asPromise: true
});

/**
 * Redux actions for loading the HelloSign singing iFrame.
 *
 * @type {Object}
 */
export const loadSigningIframe = createActions('hellosign', 'LOAD_SIGNING_IFRAME', {
    asPromise: true
});

/**
 * Redux actions for fetching the PDF Blob and the HelloSign signing URL.
 *
 * @type {Object}
 */
export const fetchPdfAndSigningUrl = createActions('hellosign', 'FETCH_PDF_SIGNING_URL', {
    asPromise: true
});

/**
 * Redux actions for validate token.
 *
 * @type {Object}
 */
export const validateToken = createActions('hellosign', 'VALIDATE_TOKEN', {
    asPromise: true
});
